<template>
    <div class="qhs-filters">
        <provider-filters :help="help" class="left-rail" />
        <div class="right-rail">
            <provider-listing class="margin" />
        </div>
    </div>
</template>

<script>
import ProviderFilters from './ProviderFilters.vue';
import ProviderListing from './ProviderListing.vue';

export default {
    components: {ProviderFilters, ProviderListing},

    props: {
        help: {type: Object, required: true},
    },

    created() {
        this.$store.dispatch('getProviders', this.$route.query);
    },
};
</script>
